import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export default function DropBanner() {
  const [drop, setDrop] = useState(null);

  useEffect(() => {
    api.getProducts()
      .then((products) => {
        const now = Date.now();
        const upcoming = products
          .filter((p) => p.status === "coming_soon" && p.drop_date && new Date(p.drop_date).getTime() > now)
          .sort((a, b) => new Date(a.drop_date) - new Date(b.drop_date));
        if (upcoming.length) setDrop(upcoming[0]);
      })
      .catch(() => {});
  }, []);

  if (!drop) return null;

  const when = new Date(drop.drop_date).toLocaleString("en-US", {
    month: "short", day: "numeric", hour: "numeric", minute: "2-digit",
  }).toUpperCase();

  return (
    <div className="border-b border-wire bg-white" data-testid="drop-banner">
      <div className="mx-auto flex max-w-[1600px] flex-wrap items-center justify-center gap-x-4 gap-y-1 px-5 py-2.5 sm:px-8">
        <p className="font-mono text-[10px] tracking-[0.3em] text-black">
          NEXT DROP — {drop.name.toUpperCase()} — {when}
        </p>
        <Link to={`/product/${drop.slug}`} data-testid="drop-banner-link"
          className="group flex items-center gap-1.5 font-mono text-[10px] tracking-[0.3em] text-black underline underline-offset-4">
          GET NOTIFIED <ArrowRight size={11} className="transition-transform group-hover:translate-x-0.5" />
        </Link>
      </div>
    </div>
  );
}
